import React from 'react'

function MissionValue() {
  return (
    <div>
      <section>
        <div className="container pb-xl-5 my-5">
          <div className="row">
            <div className="col-xxl-6 col-sm-12">
              <div className="about_us_mission_left">
                <h2>Mission , Vision , Value</h2>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of typ</p>
                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of typ</p>
                
              </div>
            </div>
            <div className="col-xxl-6 col-sm-6 d-flex justify-content-end ">
              <div className="about_us_mission_right">
                <div className='d-flex ' >
                  <img className='w-100' src="/images/mission_img/1.png" alt="img" />
                  <div className='bg-mission'>
                    <img className='px-3 w-100' src="/images/mission_img/2.png" alt="img" />
                    <img className='px-3 w-100 mt-2' src="/images/mission_img/3.png" alt="img" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default MissionValue
